import React, { FC } from "react";
import { useForm } from "react-hook-form";

import { Input, InputError, Text } from "@epignosis_llc/gnosis";
import { yupResolver } from "@hookform/resolvers/yup";

import { IconEnterSVG, LockedFileSVG } from "@assets/images";
import { passwordFormStyles } from "@components/PdfViewer/components/styles";

import { useApplyTranslations } from "@hooks";

import { PasswordFormValidationSchema } from "@components/PdfViewer/components/schemas";
import { PasswordFormData } from "@components/PdfViewer/types";

type PasswordFormProps = {
  hasError: boolean;
  onSubmit: (data: PasswordFormData) => void;
};

const PasswordForm: FC<PasswordFormProps> = ({ hasError, onSubmit }) => {
  const { t } = useApplyTranslations();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<PasswordFormData>({
    mode: "onChange",
    defaultValues: {
      password: "",
    },
    resolver: yupResolver(PasswordFormValidationSchema),
  });

  return (
    <form css={passwordFormStyles} id="pdf-password-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="info-icon">
        <LockedFileSVG />
      </div>
      <Text fontSize="sm" weight="700" as="div" className="info-text">
        {t("general.passwordRequired")}
      </Text>
      <Text fontSize="sm" as="div" className="info-text">
        {t("files.passwordProtected")}
      </Text>
      <div className="input-container">
        <Input
          {...register("password")}
          status={errors.password ? "error" : "valid"}
          type="password"
          id="password"
          data-lpignore="true"
          iconAfter={IconEnterSVG}
          aria-label={t("test.passwordProtected")}
          placeholder={t("general.insertPassword")}
          onIconClick={handleSubmit(onSubmit)}
        />
        {hasError && <InputError>{t("errors.general.invalidPassword")}</InputError>}
      </div>
    </form>
  );
};

export default PasswordForm;
